/**
 * The `source.type` values Customer.io stamps on a change it records.
 *
 * Shared rather than per-page because two surfaces read the same value and
 * must agree on it: activity logs turn it into a sentence, and the data index
 * turns it into an icon and a title. A second copy would eventually describe
 * the same source two different ways.
 *
 * The values are a backend contract — each one is written by a specific
 * service path, so they are wire strings, not display labels.
 */
export const ACTIVITY_LOG_SOURCE = {
  ListUnsubscribe: 'mx-unsubscribe.customer.io',
  TrackAPI: 'track.customer.io',
  TrackEUAPI: 'track-eu.customer.io',
  Subscriptions: 'subscriptions.customer.io',
  AttributeUpdateAction: 'attribute_update_action',
  QueryCollection: 'query_collection',
  QueryObjects: 'query_objects',
  ObjectCampaignsAudience: 'object_campaigns_audience',
  Webhook: 'webhook',
  UI: 'ui',
  UIEvent: 'ui_event',
  Import: 'import',
  ProfileMerge: 'profile merge',
  Action: 'action',
  LLMAction: 'llm_action',
  Newsletter: 'newsletter',
  Transactional: 'transactional',
  Content: 'content',
  System: 'system',
  SystemAutomaticDeletion: 'system_auto_delete',
  FormIntegration: 'form_integration',
  SQLImport: 'sql_import',
  DebugWidget: 'debug_widget',
} as const;
